import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { voidBillPayment, VoidBillPaymentResponseData } from '../query-api'

interface UseVoidBillPaymentProps {
  onError?: (error?: APIError) => void
  onSettled?: (data: VoidBillPaymentResponseData | undefined, error: APIError | null | undefined) => void
  onSuccess?: (data: VoidBillPaymentResponseData) => void
}

export const useVoidBillPayment = (props?: UseVoidBillPaymentProps) => {
  const { onError, onSuccess, onSettled } = props || {}
  const { mutate: update, ...rest } = useMutation(voidBillPayment, {
    onSuccess,
    onError,
    onSettled,
  })

  return { update, ...rest }
}
